import React, { useState } from "react";
import products from "../data/products";

const Shop = () => {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all");

  const categories = ["all", ...new Set(products.map((p) => p.category))];

  const filtered = products.filter((p) => {
    const matchCat = category === "all" || p.category === category;
    const matchSearch =
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.description.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <>
      <section
        className="page-hero"
        style={{ backgroundImage: "url('/images/hero.jpg')" }}
      >
        <div className="container">
          <h1>Shop</h1>
        </div>
      </section>

      <section className="section container">
        <div className="shop-controls">
          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="category-filters">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`btn-filter ${category === cat ? "active" : ""}`}
                onClick={() => setCategory(cat)}
              >
                {cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="product-grid">
          {filtered.length === 0 ? (
            <p>No products found.</p>
          ) : (
            filtered.map((product) => (
              <div className="product-card" key={product.id}>
                <img src={product.image} alt={product.name} />
                <h3>{product.name}</h3>
                <p className="price">{product.price}</p>
                <p className="desc">{product.description}</p>
              </div>
            ))
          )}
        </div>
      </section>
    </>
  );
};

export default Shop;
